import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { LocationInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { LocationDetailSaveModel } from '../models/location-detail-save.model';
import { deleteLocationMutation } from '../queries/delete-location.graphql';
import { DeleteLocationVariables } from '../queries/generated/DeleteLocation';
import { SaveLocation, SaveLocationVariables } from '../queries/generated/SaveLocation';
import { SaveLocationMutation } from '../queries/save-location.graphql';

@Injectable({ providedIn: 'root' })
export class LocationDetailApiService {
   constructor(private apiService: LcsApiService, private http: HttpClient) {}

   save(
      locationDetail: LocationDetailSaveModel,
      fields: (keyof LocationInput)[]
   ): Observable<ExecutionResult<SaveLocation>> {
      return this.apiService.query<SaveLocation, SaveLocationVariables>({
         query: SaveLocationMutation,
         variables: {
            location: {
               ...locationDetail,
               fields: fields,
            },
         },
      });
   }

   deleteLocation(locationId: number): Observable<ExecutionResult<void>> {
      return this.apiService.query<void, DeleteLocationVariables>({
         query: deleteLocationMutation,
         variables: {
            locationId,
         },
      });
   }
}
